<div class="tree-node-content" [style.padding-left]="node.level * 20 + 'px'">
  @if (!node.leaf) {
    <button type="button" class="tree-node-toggle-button" (click)="toggleExpanded()" tabindex="-1">
      @if (!node.loading) {
        @if (!node.expanded) {
          <i class="fa-solid fa-chevron-right tree-node-toggle-icon"></i>
        }
        @if (node.expanded) {
          <i class="fa-solid fa-chevron-down tree-node-toggle-icon"></i>
        }
      }
      @if (node.loading) {
        <i class="fa-solid fa-spinner fa-spin tree-node-toggle-icon"></i>
      }
    </button>
  }
  @if (node.leaf) {
    <span class="tree-node-toggle-button">
      <!-- Use invisible icon for leaf nodes to maintain alignment -->
      <i class="fa-solid fa-chevron-right tree-node-toggle-icon" style="visibility: hidden"></i>
    </span>
  }

  <div class="checkbox-container" [class.pointer-events-none]="readonly" [class.opacity-50]="readonly">
    <input
      tooltipStyleClass="arp-tooltip"
      [id]="node.key"
      [pTooltip]="node.shouldDisplayTooltip ? tooltipContent : null"
      tooltipPosition="right"
      [autoHide]="false"
      type="checkbox"
      class="arpio-checkbox"
      [ngClass]="{ 'weak-dependency': node.isWeakDependency, suppressed: node.isWeakDependency && !node.checked }"
      (input)="onSelectionChange($event)"
      [indeterminate]="node.partialSelected"
      [disabled]="!node.selectable && node.checked"
      [checked]="node.checked && !node.isExcluded"
      [hideDelay]="200"
      tooltipEvent="hover"
    />
    @if (node.isExcluded) {
      <i class="fa-utility fa-semibold fa-xmark exclusion-overlay" aria-hidden="true"></i>
    }
  </div>
  <div class="tree-node-label" [innerHTML]="node.label"></div>

  <ng-template #tooltipContent>
    <div class="tooltip-container" (mouseenter)="keepTooltipVisible()" (mouseleave)="hideTooltipDelayed()">
      @for (section of node.tooltipData?.sections; track section) {
        <div class="tooltip-section">
          <!-- Exclusion section -->
          @if (section.type === 'exclusion') {
            <div [innerHTML]="section.text"></div>
          }
          <!-- Weak dependency section -->
          @if (section.type === 'weakDependency') {
            <div [innerHTML]="section.text"></div>
          }
          <!-- Tags or type section -->
          @if (section.type === 'tags' || section.type === 'resourceType') {
            <div [innerHTML]="section.text"></div>
          }
          <!-- Dependees section with precise clipboard placement -->
          @if (section.type === 'dependees') {
            <div class="dependees-section">
              <div class="dependees-header">
                {{ section.text }}
              </div>
              <div class="flex-row-start">
                <div>
                  <i
                    class="fa-utility fa-semibold fa-copy clipboard-icon"
                    (click)="copySpecificArns(section.allDependeeArns)"
                    title="Copy all resource ARNs"
                  >
                  </i>
                </div>
                <div class="dependee-list">
                  @for (dependee of section.dependeeResources; track dependee) {
                    <div class="dependee-item" [innerHTML]="dependee.displayText"></div>
                  }
                  @if (section.moreCount > 0) {
                    <div class="more-resources">...{{ section.moreCount }} more resources</div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      }

      <!-- Fallback for nodes without structured data -->
      @if (!node.tooltipData?.sections?.length) {
        <span [innerHTML]="node.tooltip"></span>
      }
    </div>
  </ng-template>
</div>
